<script async setup lang="ts">
import { encode } from 'html-entities'
import moment from 'moment'
import LiteYouTubeEmbed from 'vue-lite-youtube-embed'
// import ExampleBrowser from '~/components/OgImage/Example.browser.vue'

// import { defineVideo, useSchemaOrg } from '@unhead/schema-org'

// import '@/node_modules/vue-lite-youtube-embed/dist/index.css'
const isDev = process.env.NODE_ENV === 'development'

const route = useRoute()

const { data } = await useFetch(
  `/api/watch?year=${route.params.year}&episode=${route.params.episode}`,
  { key: route.params.episode.toString() },
)

const show = ref(null)
show.value = data.value.show

const { GenerateTags } = useSEO()

if (data.value.show.podcast_link) {
  GenerateTags({
    title: '👂  CQPOD',
    desc: `${show.value.date} | ${show.value.yt_title}`,
    image: 'https://crappyquizchamps.com/images/retro_radio1.jpg',
  })
}
else {
  // GenerateTags({
  //   title: `📺 ${show.value.yt_title} | CQTV`,
  //   desc: `${show.value.date} | ${show.value.yt_title}`,
  //   // image: 'https://i.ytimg.com/vi/' + route.params.episode + '/hqdefault.jpg'
  //   image: `/_og/d/shows/watch/${route.params.year}` + `$` + `${route.params.episode}/og.jpg?${Date.now()}`,
  //   // image: isDev ? `http:localhost:3000/__og_image__/shows/watch/${route.params.year}` + '$' + `${route.params.episode}og.png` : `https://crappyquizchamps.com/shows/watch/${route.params.year}` + '$' + `${route.params.episode}/__og_image__/og.png`
  // })
  // defineOgImage('TestImageSatori', {
  //   yt_date: show.value.date,
  //   yt_title: show.value.yt_title,
  //   winner: show.value.winner,
  //   yt_image: `/images/yt-thumbs/${route.params.episode}.jpg`,
  // })

  // defineOgImage('ExampleBrowser')

  defineOgImage('Example.takumi', {
    desc: encode(show.value.yt_title),
    winner: show.value.winner,
    ytImage: encode(`/images/yt-thumbs/${route.params.episode}.jpg`),
  })

  // defineOgImage('SimpleBlog.satori', {
  //   title: show.value.winner,
  //   description: show.value.winner,
  // })

  useSchemaOrg([
    defineVideo({
      name: show.value.yt_title,
      uploadDate: moment(show.value.date, 'DD/MM/YYYY').locale('en-ie').format('YYYY-MM-DD'),
      url: `https://crappyquizchamps.com//images/yt-thumbs/${route.params.episode}.jpg`,
      height: 320,
      width: 240,
      isFamilyFriendly: true,
      embedUrl: `https://www.youtube.com/watch?v=${route.params.episode.toString()}`,
      contentUrl: `https://crappyquizchamps.com/images/yt-thumbs/${route.params.episode}.jpg`,
      thumbnailUrl: `https://crappyquizchamps.com/images/yt-thumbs/${route.params.episode}.jpg`,
    }),
    defineWebPage(),
  ])
}
</script>

<template>
  <div>
    <TheShowNav />
    <div class="pl-4 sm:px-10 py-8 sm:py-3">
      <div class="pb-16 flex justify-center">
        <div class="uppercase inline-flex items-center dark:text-gray-50 absolute">
          <span
            class="p-x-2 p-y-0.5 sg-bold mtv-shadow text-white text-3xl bg-[#ec0007] relative z-0 text-stroke-1.7 tracking-wide text-transparent text-stroke-white"
          >crappy quiz</span>
          <NuxtImg
            preload
            src="/images/MTV-Logo.svg"
            alt="logo"
            class="w-12 relative absolute -top-5  right-5 rotate-2"
          />
        </div>
      </div>
      <div class="md:flex dark:text-gray-50 ">
        <div v-if="show.podcast_link" class="pr-6 sm:pr-0 w-full md:w-1/2 pb-6">
          <div class="">
            <NuxtImg
              src="/images/retro_radio1.png"
              alt="old timey radio"
              class="object-center w-full"
              height="572"
              width="800"
            />
            <div class="flex justify-center">
              <div>No youtubes, podcast only. Click</div>
              <div class="right pl-3 px-2">
                👉
              </div>
              <div>
                <NuxtLink
                  :to="show.podcast_link"
                  class="wavy-text"
                  no-prefetch
                  target="_blank"
                >
                  me.
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="pr-6 sm:pr-0 w-full md:w-1/2 pb-6">
          <div class="mtv-tv-shadow border-4 border-[#ec0007]">
            <LiteYouTubeEmbed
              :id="route.params.episode"
              :title="show.yt_title"
              :params="show.yt_params"
            />
          </div>
        </div>
        <div class="w-full md:w-1/2 px-6">
          <div class="sg-bold text-center text-lg pb-6 show-name">
            {{ show.yt_title }}
          </div>
          <div class="w-full uppercase flex justify-center">
            <div class="">
              <div class="">
                <div class="flex pb-2">
                  <div class="sg-medium w-30">
                    quizmaster
                  </div>
                  <div class="sg-regular">
                    {{ show.presenter }}
                  </div>
                </div>
                <div class="flex pb-2">
                  <div class="sg-medium w-30">
                    winner
                  </div>
                  <div class="sg-regular">
                    <NuxtLink
                      :to="`/champ/${show.winner_id.toLowerCase()}`"
                      class="wavy-text"
                    >
                      {{ show.winner }}
                    </NuxtLink>
                  </div>
                </div>
                <div class="flex">
                  <div class="sg-medium w-30">
                    contestants
                  </div>
                  <div class="sg-regular">
                    <NuxtLink
                      :to="`/champ/${show.contestants[0].name_id}`"
                      class="wavy-text"
                    >
                      {{ show.contestants[0].name }}
                    </NuxtLink>
                  </div>
                </div>
                <div class="flex">
                  <div class="sg-medium w-30" />
                  <div class="sg-regular">
                    <NuxtLink
                      :to="`/champ/${show.contestants[1].name_id}`"
                      class="wavy-text"
                    >
                      {{ show.contestants[1].name }}
                    </NuxtLink>
                  </div>
                </div>
                <div class="flex pb-2">
                  <div class="sg-medium w-30" />
                  <div class="sg-regular">
                    <NuxtLink
                      :to="`/champ/${show.contestants[2].name_id}`"
                      class="wavy-text"
                    >
                      {{ show.contestants[2].name }}
                    </NuxtLink>
                  </div>
                </div>
                <div class="flex">
                  <div class="sg-medium w-30">
                    aired on
                  </div>
                  <div class="sg-regular">
                    {{ show.show_date }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <ExampleTakumi :winner="show.winner" :desc="show.yt_title" :yt-image="`/images/yt-thumbs/${route.params.episode}.jpg`" /> -->
  </div>
</template>

<style lang="css">
@import 'vue-lite-youtube-embed/style.css';

.mtv-shadow {
  box-shadow: rgba(34, 197, 94, 0.5) 6px 6px;
}

.mtv-tv-shadow {
  box-shadow:
    4px 4px #f8df26,
    8px 8px rgba(34, 197, 94, 0.5);
}

/*5px 5px blue, 10px 10px red, 15px 15px green*/
.wavy-text:hover {
  text-decoration-line: underline;
  text-decoration-style: wavy;
  text-decoration-color: #ec1d23;
  text-decoration-thickness: 0.08rem;
}

.yt-lite:hover > .lty-playbtn {
  background-color: #22c55e;
  opacity: 1;
}

.yt-lite > .lty-playbtn {
  width: 70px;
  height: 46px;
  background-color: #22c55e;
  z-index: 1;
  opacity: 1;
  border-radius: 5px;
  transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
  transform: scale(1) skew(0deg, 0deg);
  left: 42%;
  top: 40%;
  box-shadow:
    4px 4px #f8df26,
    8px 8px #1e90ff;
  background-image: unset;
  filter: unset;
}

.yt-lite > .lty-playbtn::before {
  position: absolute;
  top: -10%;
  left: 25%;
  transform: translate(-50%, -50%);
  font-size: 2.2rem;
  padding: unset;
  margin: unset;
  border-radius: 100%;
  content: '🎬';
  animation: lds-heart 2.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

@keyframes lds-heart {
  0% {
    transform: scale(0.95);
  }
  5% {
    transform: scale(1.1);
  }
  39% {
    transform: scale(0.85);
  }
  45% {
    transform: scale(1);
  }
  60% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(0.9);
  }
}

.show-name {
  view-transition-name: show-name;
}

@keyframes pointright {
  0% {
    -webkit-transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(-0.3em);
    opacity: 1;
  }
}

.right {
  -webkit-animation: pointright 0.6s infinite alternate ease-in-out;
}
</style>
